<template>
  <section class="cycling-community-section">
    <div class="community-bg">
      <div class="community-overlay"></div>
    </div>
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="community-content">
            <h2 class="community-title">{{ communityData.title }}</h2>
            <p class="community-description">{{ communityData.description }}</p>
            <div class="community-stats">
              <div class="stat-item" v-for="(stat, index) in communityData.stats" :key="index">
                <div class="stat-number">{{ stat.number }}</div>
                <div class="stat-label">{{ stat.label }}</div>
              </div>
            </div>
            <button class="community-btn" @click="handleJoinClick">{{ communityData.buttonText }}</button>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="community-image">
            <img :src="communityData.image" :alt="communityData.imageAlt" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ServiceItsCommunityJoinComp",
  props: {
    communityData: {
      type: Object,
      required: true,
      default: () => ({
        title: "Join Our Cycling Community",
        description: "Connect with fellow cyclists, share experiences, and discover new biking adventures in our vibrant community.",
        stats: [
          { number: "500+", label: "Active Members" },
          { number: "50+", label: "Group Rides" },
          { number: "1000+", label: "Bikes Serviced" }
        ],
        buttonText: "Join Community",
        image: require("@/assets/resource/portfolio-01.jpg"),
        imageAlt: "Cycling Community"
      })
    }
  },
  methods: {
    handleJoinClick() {
      this.$emit('join-community');
    }
  }
};
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

/* Cycling Community Section */
.cycling-community-section {
  padding: 100px 0;
  position: relative;
  overflow: hidden;
}

.community-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #0a0f1c 0%, #1a2332 50%, #0a0f1c 100%);
  z-index: 1;
}

.community-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, 
    rgba(0, 255, 150, 0.1) 0%, 
    rgba(0, 255, 200, 0.05) 25%, 
    rgba(0, 255, 100, 0.1) 50%, 
    rgba(0, 255, 150, 0.05) 75%, 
    rgba(0, 255, 200, 0.1) 100%);
  z-index: 2;
}

.community-content {
  position: relative;
  z-index: 3;
  color: #fff;
}

.community-title {
  font-size: 48px;
  font-weight: 700;
  color: #00ff96;
  margin-bottom: 20px;
  line-height: 1.2;
  font-family: 'Archivo', sans-serif;
}

.community-description {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  margin-bottom: 40px;
  max-width: 500px;
}

.community-stats {
  display: flex;
  gap: 40px;
  margin-bottom: 40px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 36px;
  font-weight: 700;
  color: #00ff96;
  margin-bottom: 5px;
  font-family: 'Archivo', sans-serif;
}

.stat-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.community-btn {
  background: linear-gradient(135deg, #00ff96 0%, #00ff64 100%);
  color: #000;
  border: none;
  padding: 15px 30px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.community-btn:hover {
  background: linear-gradient(135deg, #00ff64 0%, #00ff96 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 255, 150, 0.3);
}

.community-image {
  position: relative;
  z-index: 3;
  text-align: center;
}

.community-image img {
  width: 100%;
  max-width: 500px;
  height: auto;
  border-radius: 15px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease;
}

.community-image img:hover {
  transform: scale(1.05);
}

/* Responsive Design */
@media (max-width: 991px) {
  .community-title {
    font-size: 36px;
  }
  
  .community-description {
    font-size: 16px;
  }
  
  .community-stats {
    gap: 30px;
  }
  
  .stat-number {
    font-size: 28px;
  }
}

@media (max-width: 767px) {
  .community-title {
    font-size: 28px;
  }
  
  .community-description {
    font-size: 14px;
  }
  
  .community-stats {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
  
  .stat-number {
    font-size: 24px;
  }
  
  .community-image {
    margin-top: 40px;
  }
}
</style>
